import React, { useState } from "react";
import "./DateValidation.css";
import { Collapse } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { Select, Row, Col,message } from "antd";

const { Option } = Select;

const days = Array.from({ length: 31 }, (_, i) => i + 1);
const months = Array.from({ length: 12 }, (_, i) => i + 1);
const currentYear = new Date().getFullYear();
const years = Array.from({ length: 100 }, (_, i) => currentYear - i);



const { Panel } = Collapse;

function DateValidation(props) {

        const [date, setDate] = useState(null);
        const [month, setMonth] = useState(null);
        const [year, setYear] = useState(null);
        const [messageApi, contextHolder] = message.useMessage();
        const [error,setError]=useState(false)
        

    const userDate = props?.date
    const handleDateValidation = () => {
        // console.log("handel back", date , month , year)

        const customeDate = `${year}-${String(month).padStart(2, '0')}-${String(date).padStart(2, '0')}`;
        // console.log("customeDate",customeDate,"userDate",userDate)

        if (customeDate === userDate) {
            messageApi.success('varified successfully.');
            props?.onBack()
        }
        else{
            messageApi.error('Please select a valid date.');
            setError(true)
            // alert("Invalid Date")
        }
    }

  return (
    <div className="datevalidation">
         {contextHolder}
      <div className="datevalidationTitle">Confirm your identity:</div>
      <div className="inDiv">
        <div className="datevalidationText">
          Confirm your identity to access this conversation.
        </div>
        <div className="textDiv">
          <p style={{ margin: "0px", fontSize: "16px" }}>
            Enter your date of birth
          </p>
          <p style={{ margin: "0px", fontWeight: "400", fontSize: "16px" }}>
            For example, 25 - 05 - 1955
          </p>
        </div>
        <Row gutter={16}>
      <Col className="date-input-group">
        <label className="input-label">Day</label>
        <Select  style={{ width: 100 }} showSearch  className="date-input"  suffixIcon={null} onChange={(value) => setDate(value)}>
          {days.map((day) => (
            <Option key={day} value={day}>
              {day}
            </Option>
          ))}
        </Select>
      </Col>
      <Col className="date-input-group">
        <label className="input-label">Month</label>
        <Select style={{ width: 120 }} showSearch className="date-input"  suffixIcon={null} onChange={(value) => setMonth(value)}>
          {months.map((month, index) => (
            <Option key={index + 1} value={index + 1}>
              {month}
            </Option>
          ))}
        </Select>
      </Col>
      <Col className="date-input-group">
        <label className="input-label" >Year</label>
        <Select style={{ width: 120 }} showSearch className="date-input" suffixIcon={null} onChange={(value) => setYear(value)}>
          {years.map((year) => (
            <Option key={year} value={year}>
              {year}
            </Option>
          ))}
        </Select>
      </Col>
     
    </Row>
     {error && (<div style={{color:"red",textAlign:"left",fontSize:"14px",paddingTop:"10px",fontWeight:"400"}}>
        Please select a valid date
      </div>)}
        <Collapse
          defaultActiveKey={["1"]}
          expandIconPosition="start"
          expandIcon={({ isActive }) => (
            <DownOutlined
            //   rotate={isActive ? 180 : 0}
               rotate={ isActive ? 0 : -90} 
              style={{ color: "teal" }}
            />
          )}
          bordered={false}
          className="custom-collapse"
        >
          <Panel
            header={<span className="header-text">Why do we need this?</span>}
            key="1"
          >
            <div className="custom-panel-content">
              This is to make sure that you are the person this link is for.
            </div>
          </Panel>
        </Collapse>
        <button className="datevalidationButton" onClick={handleDateValidation} >Confirm date of birth</button>
      </div>
    </div>
  );
}

export default DateValidation;
